  <form [formGroup]="recruteFormGroup">
    <div fxLayoutGap="10px">
      <mat-form-field appearance="fill" fxFlex="80">
        <mat-label>INM de recrutement</mat-label>
        <input formControlName="inm_recrutement"
               type="number"
               matInput
               placeholder="INM recrutement">
      </mat-form-field>
    </div>
    <div fxLayoutGap="10px">
      <mat-form-field appearance="fill" fxFlex="80">
        <mat-label>Prénom du recruté</mat-label>
        <input formControlName="first_name" [UpperCaseFirstLetter]="true"
               matInput placeholder="Prénom du recruté">
        <mat-hint align="end"><code>{{recruteFormGroup.get('first_name').value?.length}}</code> / <code>80</code></mat-hint>
      </mat-form-field>

      <mat-form-field appearance="fill" fxFlex="80">
        <mat-label>Nom du recruté</mat-label>
        <input formControlName="last_name" [UpperCaseFirstLetter]="true"
               matInput placeholder="Nom du recruté">
        <mat-hint align="end"><code>{{recruteFormGroup.get('last_name').value?.length}}</code> / <code>80</code></mat-hint>
      </mat-form-field>
    </div>

    <div>
      <mat-form-field *ngIf="displayGestSPTA" fxFlex="80">
        <mat-select formControlName="gestionnaire" placeholder="Sélectionner le gestionnaire SPTA le cas échéant"
                    (valueChange)="onSelectSPTA($event)">
          <mat-option *ngFor="let gest of gestSPTA" [value]="gest.uid">
            {{gest.last_name}} {{gest.first_name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </form>
